import { Button, Panel } from "@guestpilot/ui-kit";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../i18n";
import { useInbox } from "../lib/inbox";
import { InboxList } from "./InboxList";

/** "To do" on Home: the five latest unread notices, only when there are some. */
export function InboxPreview() {
  const { t } = useI18n();
  const nav = useNavigate();
  const q = useInbox(5, true);
  if (!q.data || q.data.items.length === 0) return null;
  return (
    <Panel label={t("ui:inbox.previewTitle")}>
      <div
        className="gp-row"
        style={{ justifyContent: "space-between", padding: "var(--space-12) var(--space-16) 0" }}
      >
        <h2 className="t-title-sm" style={{ margin: 0 }}>
          {t("ui:inbox.previewTitle")}
        </h2>
        <Button variant="ghost" onClick={() => nav("/notifications")}>
          {t("ui:inbox.seeAll")}
        </Button>
      </div>
      <InboxList items={q.data.items} />
    </Panel>
  );
}
